var map = {
	"./__tests__/loki.test": "cf0b",
	"./__tests__/loki.test.ts": "cf0b",
	"./awsElasticsearch": "a721",
	"./awsElasticsearch.vue": "a721",
	"./azurestorage": "b06b",
	"./azurestorage.vue": "b06b",
	"./cloudwatch": "1d0b",
	"./cloudwatch.vue": "1d0b",
	"./datadog": "d816",
	"./datadog.vue": "d816",
	"./elasticsearch": "dbdf",
	"./elasticsearch.vue": "dbdf",
	"./file": "2457",
	"./file.vue": "2457",
	"./forward": "4b4b",
	"./forward.vue": "4b4b",
	"./gcs": "8ac9",
	"./gcs.vue": "8ac9",
	"./gelf": "dc14",
	"./gelf.vue": "dc14",
	"./kafka": "1081",
	"./kafka.vue": "1081",
	"./kinesisStream": "f01e",
	"./kinesisStream.vue": "f01e",
	"./logdna": "666b",
	"./logdna.vue": "666b",
	"./logz": "a9b0",
	"./logz.vue": "a9b0",
	"./loki": "82e9",
	"./loki.vue": "82e9",
	"./newrelic": "1461",
	"./newrelic.vue": "1461",
	"./opensearch": "13e8",
	"./opensearch.vue": "13e8",
	"./redis": "9bc2",
	"./redis.vue": "9bc2",
	"./s3": "d438",
	"./s3.vue": "d438",
	"./splunkHec": "0a2b",
	"./splunkHec.vue": "0a2b",
	"./sumologic": "acaf",
	"./sumologic.vue": "acaf",
	"./syslog": "c9be",
	"./syslog.vue": "c9be",
	"./utils": "54ae",
	"./utils.js": "54ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e2a";